/**
 * WhatMakes: a coverflow carousel.
 *
 * Lays out the cards from each card's offset to the active card: the centre
 * card is full scale, neighbours scale down, far cards are hidden. The cards
 * stay fully opaque (so they read as solid, stacked cards); the "faded" look
 * comes from a white veil overlay (the --veil custom property on each card,
 * painted by the ::after in CSS), which keeps the cards opaque rather than
 * see-through. Navigated by arrows, clicking a side card, swiping and
 * Left/Right keys. Non-looping. data-start-index sets the default centre card.
 *
 * Inline transform/opacity have a CSS transition; the global
 * prefers-reduced-motion reset turns navigation into an instant jump.
 */
(function ($) {
    'use strict';

    function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

    function initCarousel($carousel) {
        var $viewport = $carousel.find('.mnhq-whatmakes__viewport');
        var $cards    = $carousel.find('.mnhq-whatmakes__card');
        var $prev     = $carousel.find('.mnhq-whatmakes__arrow--prev');
        var $next     = $carousel.find('.mnhq-whatmakes__arrow--next');
        var total     = $cards.length;
        if (!total) return;

        var active = parseInt($carousel.attr('data-start-index'), 10);
        if (isNaN(active)) active = Math.floor((total - 1) / 2);

        var startX = null;
        var suppressClick = false;

        $carousel.addClass('is-initialized');

        function layout() {
            var cardW = $cards.eq(0).outerWidth() || 300;
            var step  = cardW * 0.62;

            $cards.each(function (i) {
                var pos = i - active;
                var abs = Math.abs(pos);
                var scale = abs === 0 ? 1 : (abs === 1 ? 0.84 : (abs === 2 ? 0.7 : 0.6));
                var veil  = abs === 0 ? 0 : (abs === 1 ? 0.62 : (abs === 2 ? 0.82 : 0.92));
                var el = this;

                el.style.transform = 'translate(-50%, -50%) translateX(' + (pos * step) + 'px) scale(' + scale + ')';
                el.style.opacity = abs >= 3 ? '0' : '1';        // hide only the far, off-stage cards
                el.style.zIndex = String(50 - abs);
                el.style.pointerEvents = abs >= 3 ? 'none' : 'auto';
                el.style.setProperty('--veil', String(veil));   // faded, but the card stays opaque

                $(el).toggleClass('is-active', pos === 0)
                     .attr('aria-hidden', abs >= 3 ? 'true' : 'false');
            });

            $prev.prop('disabled', active === 0);
            $next.prop('disabled', active === total - 1);
        }

        function go(i) {
            active = clamp(i, 0, total - 1);
            layout();
        }

        $prev.on('click', function () { go(active - 1); });
        $next.on('click', function () { go(active + 1); });

        // Click a (non-active) card to bring it to the centre, unless the click
        // is the tail of a swipe.
        $cards.on('click', function () {
            if (suppressClick) return;
            go(parseInt($(this).attr('data-index'), 10) || 0);
        });

        // Left/Right keys when focus is anywhere in the carousel (e.g. on an arrow).
        $carousel.on('keydown', function (e) {
            if (e.key === 'ArrowLeft')  { e.preventDefault(); go(active - 1); }
            else if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
        });

        // Swipe / drag.
        $viewport.on('pointerdown', function (e) { startX = e.clientX; suppressClick = false; });
        $viewport.on('pointerup', function (e) {
            if (startX === null) return;
            var dx = e.clientX - startX;
            startX = null;
            if (Math.abs(dx) > 40) {
                suppressClick = true;
                go(active + (dx < 0 ? 1 : -1));
                setTimeout(function () { suppressClick = false; }, 0);
            }
        });
        $viewport.on('pointercancel pointerleave', function () { startX = null; });

        // Recompute the step when the card width changes.
        var rt;
        $(window).on('resize', function () {
            clearTimeout(rt);
            rt = setTimeout(layout, 150);
        });

        layout();
    }

    $(function () {
        $('.mnhq-whatmakes__carousel').each(function () { initCarousel($(this)); });
    });
})(jQuery);
